import React, { FunctionComponent } from "react";
import { graphql } from "gatsby";
import { Layout } from "../../components/layout";
import { TagCollection } from "../../components/tagCollection";
import { SEO } from "../../components/seo";
import { PostSnippetNode, toPostSnippet } from "../../data/posts";

export const pageQuery = graphql`
  query BlogPostsWithTag($tag: String!) {
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___publishedDate], order: DESC }
      filter: {
        fields: { collection: { eq: "blog" } }
        frontmatter: { tags: { eq: $tag } }
      }
    ) {
      nodes {
        ...PostSnippet
      }
    }
  }
`;

interface QueryData {
  data: {
    allMarkdownRemark: {
      nodes: PostSnippetNode[];
    };
  };
  pageContext: {
    tag: string;
  };
}

export const Page: FunctionComponent<QueryData> = ({ data, pageContext }) => {
  const relatedPost = data.allMarkdownRemark.nodes.map(toPostSnippet);
  return (
    <>
      <SEO title={pageContext.tag} image={relatedPost[0].img.src} />
      <Layout>
        <TagCollection tag={pageContext.tag} relatedPosts={relatedPost} />
      </Layout>
    </>
  );
};

export default Page;
